import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PagesService {
  sidebarMenu: boolean;
  sidebarMenuClass: boolean;
  constructor() {
    // This is intentional
  }
  currentValue = new BehaviorSubject<any>({});
  getValue = this.currentValue.asObservable();
  sendClickEvent(value: boolean) {
    this.currentValue.next(value);
  }
}
